import { Component } from '@angular/core';

@Component({
  selector: 'loading-page',
  template: `<span class="main-loading"><div class="cc-spinner"></div></span>`,
})
export class LoadingPageComponent {
}
